const MARK_SRC = "/ui_images/china-pie-mark.png";

/** Same lockup as the public site header: circular mark + ChinaPie wordmark. */
export function BrandLockup({ size = "md" }: { size?: "md" | "lg" }) {
  return (
    <div className={`cp-lockup cp-lockup--${size}`}>
      <span className="cp-lockup__mark-slot">
        <img alt="" aria-hidden className="cp-lockup__mark" decoding="async" src={MARK_SRC} />
      </span>
      <span aria-label="ChinaPie" className="cp-wordmark">
        <span aria-hidden="true">
          Ch
          <span className="cp-wordmark__i cp-wordmark__i--violet">ı</span>
          na
          <span className="cp-wordmark__cap-p">P</span>
          <span className="cp-wordmark__i cp-wordmark__i--orange">ı</span>e
        </span>
      </span>
    </div>
  );
}
